import { MutableRefObject, RefCallback, RefObject } from 'react';

/*

Sometimes we need to get the element/component ref, sometimes we need it in multiple places at once.
This tools allows us to pass multiple objects and callbacks into element/component ref.

  const elementRef = useRef();
  const [stateRef, setStateRef] = useState();
  const fakeRef = useConst(() => ({ current: null }));

  const logger = ref => console.log(ref);

  <div ref={setRef(elementRef, setStateRef, fakeRef, logger, forwardedRef)} ...>

*/

export const setRef = <T>(
  ...refs: (RefCallback<T> | RefObject<T> | MutableRefObject<T> | undefined | null)[]
) => {
  return (instance: T | null) => {
    for (const ref of refs) {
      if (!ref) continue;

      if (typeof ref === 'function') {
        ref(instance);
      }

      if ('current' in ref) {
        (ref as MutableRefObject<T | null>).current = instance;
      }
    }
  };
};
